namespace RecordShield.Workspace {
    export interface ActivationsRow {
        Id?: number;
        ProductSerialId?: number;
        UserId?: number;
        ProductId?: number;
        KeyStatus?: number;
        PublisherId?: number;
        DistributorId?: number;
        IsActive?: number;
        SubscriberEmail?: string;
        SubscriberMobile?: string;
        ProductSerialProductId?: number;
        ProductSerialSerialKey?: string;
        ProductSerialUserId?: number;
        ProductSerialViews?: number;
        ProductSerialWatchTime?: number;
        ProductSerialValidityInDays?: number;
        ProductSerialUpdateFrequencyInDays?: number;
        ProductSerialAllowSecondScreen?: boolean;
        ProductSerialInsertDate?: string;
        ProductSerialInsertUserId?: number;
        ProductSerialUpdateDate?: string;
        ProductSerialUpdateUserId?: number;
        ProductSerialIsActive?: number;
        ProductSerialStatus?: number;
        UserUsername?: string;
        UserDisplayName?: string;
        UserEmail?: string;
        UserSource?: string;
        UserPasswordHash?: string;
        UserPasswordSalt?: string;
        UserInsertDate?: string;
        UserInsertUserId?: number;
        UserUpdateDate?: string;
        UserUpdateUserId?: number;
        UserIsActive?: number;
        UserLastDirectoryUpdate?: string;
        UserUserImage?: string;
        UserIsdCode?: string;
        UserMobile?: string;
        UserParentId?: number;
        UserPackageId?: number;
        ProductCode?: number;
        ProductName?: string;
        ProductDescription?: string;
        ProductUserId?: number;
        ProductViews?: number;
        ProductWatchTime?: number;
        ProductValidityInDays?: number;
        ProductUpdateFrequencyInDays?: number;
        ProductAllowSecondScreen?: boolean;
        ProductInsertDate?: string;
        ProductInsertUserId?: number;
        ProductUpdateDate?: string;
        ProductUpdateUserId?: number;
        ProductIsActive?: number;
        TenantId?: number;
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
    }

    export namespace ActivationsRow {
        export const idProperty = 'Id';
        export const isActiveProperty = 'IsActive';
        export const nameProperty = 'ProductSerialSerialKey';
        export const localTextPrefix = 'Workspace.Activations';
        export const lookupKey = 'Workspace.Activations';

        export function getLookup(): Q.Lookup<ActivationsRow> {
            return Q.getLookup<ActivationsRow>('Workspace.Activations');
        }

        export namespace Fields {
            export declare const Id: string;
            export declare const ProductSerialId: string;
            export declare const UserId: string;
            export declare const ProductId: string;
            export declare const KeyStatus: string;
            export declare const PublisherId: string;
            export declare const DistributorId: string;
            export declare const IsActive: string;
            export declare const SubscriberEmail: string;
            export declare const SubscriberMobile: string;
            export declare const ProductSerialProductId: string;
            export declare const ProductSerialSerialKey: string;
            export declare const ProductSerialUserId: string;
            export declare const ProductSerialViews: string;
            export declare const ProductSerialWatchTime: string;
            export declare const ProductSerialValidityInDays: string;
            export declare const ProductSerialUpdateFrequencyInDays: string;
            export declare const ProductSerialAllowSecondScreen: string;
            export declare const ProductSerialInsertDate: string;
            export declare const ProductSerialInsertUserId: string;
            export declare const ProductSerialUpdateDate: string;
            export declare const ProductSerialUpdateUserId: string;
            export declare const ProductSerialIsActive: string;
            export declare const ProductSerialStatus: string;
            export declare const UserUsername: string;
            export declare const UserDisplayName: string;
            export declare const UserEmail: string;
            export declare const UserSource: string;
            export declare const UserPasswordHash: string;
            export declare const UserPasswordSalt: string;
            export declare const UserInsertDate: string;
            export declare const UserInsertUserId: string;
            export declare const UserUpdateDate: string;
            export declare const UserUpdateUserId: string;
            export declare const UserIsActive: string;
            export declare const UserLastDirectoryUpdate: string;
            export declare const UserUserImage: string;
            export declare const UserIsdCode: string;
            export declare const UserMobile: string;
            export declare const UserParentId: string;
            export declare const UserPackageId: string;
            export declare const ProductCode: string;
            export declare const ProductName: string;
            export declare const ProductDescription: string;
            export declare const ProductUserId: string;
            export declare const ProductViews: string;
            export declare const ProductWatchTime: string;
            export declare const ProductValidityInDays: string;
            export declare const ProductUpdateFrequencyInDays: string;
            export declare const ProductAllowSecondScreen: string;
            export declare const ProductInsertDate: string;
            export declare const ProductInsertUserId: string;
            export declare const ProductUpdateDate: string;
            export declare const ProductUpdateUserId: string;
            export declare const ProductIsActive: string;
            export declare const TenantId: string;
            export declare const InsertUserId: string;
            export declare const InsertDate: string;
            export declare const UpdateUserId: string;
            export declare const UpdateDate: string;
        }

        ['Id', 'ProductSerialId', 'UserId', 'ProductId', 'KeyStatus', 'PublisherId', 'DistributorId', 'IsActive', 'SubscriberEmail', 'SubscriberMobile', 'ProductSerialProductId', 'ProductSerialSerialKey', 'ProductSerialUserId', 'ProductSerialViews', 'ProductSerialWatchTime', 'ProductSerialValidityInDays', 'ProductSerialUpdateFrequencyInDays', 'ProductSerialAllowSecondScreen', 'ProductSerialInsertDate', 'ProductSerialInsertUserId', 'ProductSerialUpdateDate', 'ProductSerialUpdateUserId', 'ProductSerialIsActive', 'ProductSerialStatus', 'UserUsername', 'UserDisplayName', 'UserEmail', 'UserSource', 'UserPasswordHash', 'UserPasswordSalt', 'UserInsertDate', 'UserInsertUserId', 'UserUpdateDate', 'UserUpdateUserId', 'UserIsActive', 'UserLastDirectoryUpdate', 'UserUserImage', 'UserIsdCode', 'UserMobile', 'UserParentId', 'UserPackageId', 'ProductCode', 'ProductName', 'ProductDescription', 'ProductUserId', 'ProductViews', 'ProductWatchTime', 'ProductValidityInDays', 'ProductUpdateFrequencyInDays', 'ProductAllowSecondScreen', 'ProductInsertDate', 'ProductInsertUserId', 'ProductUpdateDate', 'ProductUpdateUserId', 'ProductIsActive', 'TenantId', 'InsertUserId', 'InsertDate', 'UpdateUserId', 'UpdateDate'].forEach(x => (<any>Fields)[x] = x);
    }
}
